import React, { useState } from "react";

import "./DRPSummaryList.scss";
import ActionDropdown from "../ActionDropdown";
import { drpSummaryListHeaders, SECTION } from "../../constants";
import { headerText } from "../../RegulatoryActionForm/constants";
import { headerText as sectionCiv } from "../../CivilJudicialForm/constants";
import DeleteModal from "../DeleteModal";
import DRPSummaryListMobile from "./DRPSummaryListMobile";

const regulatorySectionsList = [
  headerText.REG,
  headerText.REG_FORM_INV,
  headerText.REG_FORM_ACT,
  headerText.REG_PRO_SUSP,
  headerText.REG_ACT_SRO,
  headerText.REG_ACT_REG,
  headerText.REG_SEC_CFTC,
];

const descStyle = {
  marginTop: "5px",
  marginBottom: "5px",
};

const DRPSummaryList = ({
  list,
  isLoading = false,
  deleteDRP = () => {},
  editDRP = () => {},
  section = "",
}) => {
  const [show, setShow] = useState(false);

  const [sectionState, setSectionState] = useState(null);
  const [questionKeyState, setQuestionKeyState] = useState(null);
  const [mainIndexState, setMainIndexState] = useState(null);
  const [indexState, setIndexState] = useState(null);

  const isRegulatory = regulatorySectionsList.includes(section);
  const isIndividualCriminalDisclosure = [
    SECTION.individualCriminalDisclosure,
  ].includes(section);
  const isOrgCriminalDisclosure =
    section === SECTION.organizationCriminalDisclosure;
  const isCustomerComplaintArbitrationCivilLitigation =
    section === SECTION.customerComplaintArbitrationCivilLitigation;
  const isBond = section === SECTION.bondDisclosures;
  const isJudgmentLien = section === SECTION.judgementLienDisclosures;
  const isTermination = section === SECTION.terminationDisclosures;
  const isOrgBankruptcy = section === SECTION.organizationBankruptcy;
  const isPersBankruptcy = section === SECTION.personalBankruptcy;
  const isCivilJud = section === sectionCiv.CIV_JUD_ACT;
  const isInvestigation = section === headerText.REG_FORM_INV;

  const numberOfColumns = () => {
    if (isTermination || isBond) {
      return "two-col";
    } else if (isIndividualCriminalDisclosure) {
      return "ind-crim-row";
    } else if (isOrgCriminalDisclosure) {
      return "org-crim-row";
    } else if (isRegulatory && !isInvestigation) {
      return "regulatory-row";
    } else if (isInvestigation) {
      return "investigation-row";
    } else if (isCivilJud) {
      return "civil-judicial-row";
    } else if (isCustomerComplaintArbitrationCivilLitigation) {
      return "customer-complaint-row";
    } else if (isPersBankruptcy) {
      return "personal-bankruptcy-row";
    } else if (isOrgBankruptcy) {
      return "organizational-bankruptcy-row";
    } else if (isJudgmentLien) {
      return "judgment-lien-row";
    } else {
      return "";
    }
  };
  const getDRPSummarylistHeader = () => {
    return (
      <div className="list-header">
        <div className={`left ${numberOfColumns()}`}>
          {isIndividualCriminalDisclosure ? (
            <>
              {drpSummaryListHeaders.indCriminal.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isOrgCriminalDisclosure && (
            <>
              {drpSummaryListHeaders.orgCriminal.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          )}
          {isRegulatory && !isInvestigation ? (
            <>
              {drpSummaryListHeaders.regulatoryAction.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isInvestigation ? (
            <>
              {drpSummaryListHeaders.investigation.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isCivilJud ? (
            <>
              {drpSummaryListHeaders.civilJudicial.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isCustomerComplaintArbitrationCivilLitigation ? (
            <>
              {drpSummaryListHeaders.customerComplaint.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isTermination ? (
            <>
              {drpSummaryListHeaders.termination.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isPersBankruptcy ? (
            <>
              {drpSummaryListHeaders.personalBankruptcy.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isOrgBankruptcy ? (
            <>
              {drpSummaryListHeaders.orgBankruptcy.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isBond ? (
            <>
              {drpSummaryListHeaders.bond.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
          {isJudgmentLien ? (
            <>
              {drpSummaryListHeaders.judgmentLien.map((header, key) => {
                return <div key={key}>{header}</div>;
              })}
            </>
          ) : null}
        </div>
        <div className="action">Action</div>
      </div>
    );
  };
  return (
    <div className="drp-sum-list">
      {getDRPSummarylistHeader()}
      <hr />
      <div className="rows">
        {list.map(
          (
            {
              date,
              description,
              status = "",
              qKey: questionKey,
              questionKey: qK = "",
              isDraft,
              orgName,
              mainIndex,
            },
            index
          ) => (
            <div key={`${index}-${questionKey || qK}`} className="rows-wrapper">
              <div
                className={isDraft ? "drp-list-row is-draft" : "drp-list-row"}
              >
                <div
                  className={`left ${numberOfColumns()}`}
                  style={{ pointerEvents: "none" }}
                >
                  {isIndividualCriminalDisclosure ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                    </>
                  ) : null}
                  {isOrgCriminalDisclosure ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{orgName || "N/A"}</div>
                      <div>
                        {description?.length
                          ? description?.map((desc, i) => (
                              <div
                                title={desc || ""}
                                key={`${desc}_${i * 1}`}
                                style={{ ...descStyle }}
                              >
                                {desc || "N/A"}
                              </div>
                            ))
                          : "N/A"}
                      </div>
                    </>
                  ) : null}
                  {isRegulatory && !isInvestigation ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                      <div>{status || "N/A"}</div>
                    </>
                  ) : null}
                  {isInvestigation ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                      <div>{status || "N/A"}</div>
                    </>
                  ) : null}
                  {isCivilJud ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                      <div>{status || "N/A"}</div>
                    </>
                  ) : null}
                  {isCustomerComplaintArbitrationCivilLitigation ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                      <div>{orgName || "Pending"}</div>
                    </>
                  ) : null}
                  {isTermination ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                    </>
                  ) : null}
                  {isPersBankruptcy ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div
                        style={{
                          marginTop: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        {description?.length
                          ? description?.map((desc, i) => (
                              <div
                                title={desc || ""}
                                key={`${desc}_${i * 1}`}
                                style={{ ...descStyle }}
                              >
                                {desc || "N/A"}
                              </div>
                            ))
                          : "N/A"}
                      </div>
                      <div
                        style={{
                          ...descStyle,
                        }}
                      >
                        {status?.length ? (
                          <div
                            key={`${status}_${index}`}
                            style={{
                              ...descStyle,
                            }}
                          >
                            {status || "N/A"}
                          </div>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </>
                  ) : null}
                  {isOrgBankruptcy ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{orgName || "N/A"}</div>
                      <div
                        style={{
                          marginTop: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        {description?.length
                          ? description?.map((desc, i) => (
                              <div
                                title={desc || ""}
                                key={`${desc}_${i * 1}`}
                                style={{ ...descStyle }}
                              >
                                {desc || "N/A"}
                              </div>
                            ))
                          : "N/A"}
                      </div>
                      <div
                        style={{
                          ...descStyle,
                          marginRight: "12px",
                        }}
                      >
                        {status?.length ? (
                          <div
                            key={`${status}_${index}`}
                            style={{
                              ...descStyle,
                            }}
                          >
                            {status || "N/A"}
                          </div>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </>
                  ) : null}
                  {isBond ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                    </>
                  ) : null}
                  {isJudgmentLien ? (
                    <>
                      <div>{date || "N/A"}</div>
                      <div>{description || "N/A"}</div>
                      <div>{orgName || "N/A"}</div>
                    </>
                  ) : null}
                </div>
                <div className="action">
                  <ActionDropdown
                    questionKey={questionKey || qK}
                    isFullWidth
                    showDelete={show}
                    isLoading={isLoading}
                    editAction={() => {
                      editDRP({
                        section,
                        questionKey: questionKey || qK,
                        dataIndex: mainIndex,
                        index,
                        isDraft,
                      });
                    }}
                    deleteAction={() => {
                      setSectionState(section);
                      setQuestionKeyState(questionKey || qK);
                      setMainIndexState(mainIndex);
                      setIndexState(index);
                      setShow(true);
                    }}
                  />
                </div>
              </div>
              <DRPSummaryListMobile
                date={date}
                description={description}
                status={status}
                questionKey={questionKey}
                qK={qK}
                orgName={orgName}
                mainIndex={mainIndex}
                index={index}
                isRegulatory={isRegulatory}
                isIndividualCriminalDisclosure={isIndividualCriminalDisclosure}
                isOrgCriminalDisclosure={isOrgCriminalDisclosure}
                isCustomerComplaintArbitrationCivilLitigation={
                  isCustomerComplaintArbitrationCivilLitigation
                }
                isBond={isBond}
                isJudgmentLien={isJudgmentLien}
                isTermination={isTermination}
                isOrgBankruptcy={isOrgBankruptcy}
                isPersBankruptcy={isPersBankruptcy}
                isCivilJud={isCivilJud}
                isInvestigation={isInvestigation}
                editAction={() => {
                  editDRP({
                    section,
                    questionKey: questionKey || qK,
                    dataIndex: mainIndex,
                    index,
                    isDraft,
                  });
                }}
                deleteAction={() => {
                  setSectionState(section);
                  setQuestionKeyState(questionKey || qK);
                  setMainIndexState(mainIndex);
                  setIndexState(index);
                  setShow(true);
                }}
              ></DRPSummaryListMobile>
              <div>
                <hr />
              </div>
              <DeleteModal
                isOpen={show}
                showSpinner={false}
                closeClick={() => setShow(false)}
                deleteClick={() => {
                  if (
                    questionKeyState &&
                    (sectionState || sectionState === 0) &&
                    (mainIndexState || mainIndexState === 0) &&
                    (indexState || indexState === 0)
                  ) {
                    deleteDRP({
                      section: sectionState,
                      questionKey: questionKeyState,
                      dataIndex: mainIndexState,
                      index: indexState,
                    });
                  }

                  setShow(false);
                }}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DRPSummaryList;
